<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="querySearch"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch" :loading="loadSeach">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" @click="finishEntry()" style="margin-top:20px;float:right">录入完成</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column label="序号" type="index" width="80"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="所属分类" prop="CATALOG_NAME"></el-table-column>
          <el-table-column label="单价" prop="PRICE"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="addProduct(scope.row)">新增</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
            <el-form-item label="产品名称：">
              <span>{{ this.addForm.NAME }}</span>
            </el-form-item>
            <el-form-item label="单位：">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
              <span>{{ this.addForm.TYPE_UNIT }}</span>
            </el-form-item>
            <el-form-item label="单价：">
              <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.PRICE"></el-input>
            </el-form-item>
            <el-form-item label="订购数量：">
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.count"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
              <el-input @keyup.enter.native="submitAdd" v-model="addForm.comment"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button @click="submitAdd">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      loading: false,
      loadSeach: false,
      searchForm: {},
      tableData: [],
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
  methods: {
    querySearch() {
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 10,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PRODUCT_NAME: this.searchForm.name,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SEND_DAY: sessionStorage.getItem('send_day'),
      };
      this.loadSeach = true;
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
        this.loadSeach = false;
      }).catch((error) => {
        this.loadSeach = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.querySearch();
    },
    addProduct(row) {
      this.addFormVisible = true;
      this.addForm = row;
      this.addForm.nowPrice = row.PRICE;
    },
    close() {
      this.addFormVisible = false;
    },
    submitAdd() {
      if (this.addForm.PRICE !== this.addForm.nowPrice) {
        this.changePrice();
        this.addOrderProduct();
      } else {
        this.addOrderProduct();
      }
    },
    changePrice() {
      if (!validation.价格正数0验证(this.addForm.PRICE)) {
        this.$message.show({ text: '请输入非负数单价', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 11,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        PRICE: this.addForm.PRICE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '提交成功', type: 'success' });
        this.searchForm = {};
        this.tableData = [];
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addOrderProduct() {
      if (!validation.价格正数0验证(this.addForm.PRICE)) {
        this.$message.show({ text: '请输入非负数单价', type: 'warning' });
        return false;
      }
      if (util.JudgmentUnit(this.addForm.TYPE_UNIT) ? !validation.数量正数验证(this.addForm.count) : !validation.数量整数正数验证(this.addForm.count)) {
        this.$message.show({ text: '请输入正数数量', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TP_ID: this.addForm.TP_ID,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: sessionStorage.getItem('orderId'),
        PRODUCT_COUNT: this.addForm.count,
        PRODUCT_COMMENT: this.addForm.comment,
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      if (this.addForm.PRICE) {
        params.PRICE = this.addForm.PRICE;
      }
      this.loading = true;
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.loading = false;
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    finishEntry() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10004',
            OTYPE: 3,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            ORDER_ID: sessionStorage.getItem('orderId'),
            ORDER_CODE: sessionStorage.getItem('orderCode'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
          };
          http.post(params).then((result) => {
            this.$router.push({ name: 'addOrder' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sellOrderManage/addProduct.vue